import { gridSizeMdLg2 } from "@/shared";
import { Button, Grid } from "@mui/material";
import { ReactNode } from "react";

interface CustomGoupButtomProps {
  handleButtonClick: (value: number) => void;
  activeButton: number;
  children?: ReactNode;
  buttonSize?: "small" | "medium" | "large"; // Tamaño del botón
  titleBtnTextPrimary?: string;
  titleBtnTextSecondary?: string;
}

export default function CustomGroupButton({
  handleButtonClick,
  activeButton,
  children,
  buttonSize = "medium", // Valor por defecto
  titleBtnTextPrimary,
  titleBtnTextSecondary
}: CustomGoupButtomProps) {
  return (
    <>
      <Grid container spacing={1} justifyContent={"start"} justifyItems={'center'}>
        {/* Botón "Productos Pendientes" */}
        <Grid item {...gridSizeMdLg2}>
          <Button
            onClick={() => handleButtonClick(1)}
            variant="contained"
            sx={{
              width: "100%",
              backgroundColor: activeButton === 1 ? "#2C4E80" : "white",
              color: activeButton === 1 ? "white" : "#6C737F",
              borderRadius: "10px", // Aumento del radio para bordes más redondeados
              textTransform: "none",
              padding: "8px 16px", // Ajuste del padding para reducir el tamaño
              "&:hover": {
                backgroundColor: activeButton === 1 ? "#2C4E80" : "#f0f0f0",
                color: activeButton === 1 ? "white" : "#2C4E80",
              },
            }}
            size={buttonSize}
          >
            {titleBtnTextPrimary}
          </Button>
        </Grid>

        {/* Botón "Productos Completados" */}
        <Grid item {...gridSizeMdLg2}>
          <Button
            onClick={() => handleButtonClick(2)}
            variant="contained"
            sx={{
              whiteSpace: "nowrap",     
              width: "100%",
              backgroundColor: activeButton === 2 ? "#2C4E80" : "white",
              color: activeButton === 2 ? "white" : "#6C737F",
              borderRadius: "10px", // Aumento del radio para bordes más redondeados
              textTransform: "none",
              padding: "8px 16px", // Ajuste del padding para reducir el tamaño
              "&:hover": {
                backgroundColor: activeButton === 2 ? "#2C4E80" : "#f0f0f0",
                color: activeButton === 2 ? "white" : "#2C4E80",
              },
            }}
            size={buttonSize}
          >
            {titleBtnTextSecondary}
          </Button>
        </Grid>
      </Grid>

      {/* Espacio para el contenido adicional */}
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </>
  );
}
